function Project(deck) {
    console.warn('TODO Magma', deck);
    // let self = {},
    //     priv = {};

    // /* Constructor */

    // priv.init = function (deck) {
    //     priv._deck = null;
    //     priv._layers = [];
    //     priv._mapsName = [];
    //     priv._maps = [];

    //     if (deck || false) {
    //         self.setDeck(deck);
    //     }
    // };

    // /* Public methods */

    // self.addLayer = function (n) {
    //     let layer;
    //     n = Math.abs(n >> 0) + 1;
    //     if (priv._deck === null) {
    //         return;
    //     }
    //     if (priv._layers.length == n) {
    //         return;
    //     }
    //     while (priv._layers.length < n) {
    //         /* Create the layer */
    //         layer = yengin
    //             .canvas(yengin.getNewObj('canvas'))
    //             .css({
    //                 position: 'absolute',
    //                 top: 0,
    //                 left: 0,
    //                 zIndex: priv._layers.length + 1
    //             })
    //             .size('100%', '100%');
    //         /* Add it */
    //         priv._deck.addChild(layer);
    //         priv._layers.push(layer);
    //         /* Quality */
    //         layer.dpp('auto', 'auto');
    //     }
    // };

    // self.addMap = function (map) {
    //     if ((map || {}).constructor.name == 'Magma.Map') {
    //         priv._mapsName.push(map.getName());
    //         priv._maps.push(map);
    //     }
    //     return self;
    // };

    // self.drawMap = function (map) {
    //     let cells, offset;
    //     map = self.getMap(map);
    //     if (map) {
    //         cells = map.getCells();
    //         offset = map.getOffset();
    //         /* Clean up the layers */
    //         self.cleanLayers();
    //         /* For each cells */
    //         yengin.each(cells, function (cell) {
    //             self.addLayer(cell.z); // create if not exists
    //             /* Draw the image */
    //             priv._layers[cell.z].drawImage({
    //                 src: cell.source.get(),
    //                 img: {
    //                     w: offset.x,
    //                     h: offset.y,
    //                     x: cell.tx * offset.x,
    //                     y: cell.ty * offset.y
    //                 },
    //                 cvs: {
    //                     w: offset.x,
    //                     h: offset.y,
    //                     x: cell.x * offset.x,
    //                     y: cell.y * offset.y
    //                 }
    //             });
    //         });
    //     }
    // };

    // self.cleanLayers = function () {
    //     yengin.each(priv._layers, function (layer) {
    //         layer.clear();
    //     });
    // };

    // /* Getters */

    // self.getDeck = function () {
    //     return priv._deck;
    // };

    // self.getMap = function (map) {
    //     if (map.constructor.name == 'Magma.Map') {
    //         return map;
    //     } else if (yengin.istype(map, 'String')) {
    //         if (priv._mapsName.indexOf(map) >= 0) {
    //             return priv._maps[priv._mapsName.indexOf(map)];
    //         }
    //     } else if (yengin.istype(map, 'Number')) {
    //         if (yengin.isset(priv._maps[map >> 0])) {
    //             return priv._maps[map >> 0];
    //         }
    //     }
    //     return false;
    // };

    // /* Setters */

    // self.setDeck = function (deck) {
    //     deck = yengin(deck || '');
    //     deck.css({ position: 'relative' });
    //     priv._deck = deck;
    //     return self;
    // };

    // /* Signature */
    // self.constructor = { name: 'Magma.Project' };
    // return priv.init(deck), self;
}

export default Project;
